// extracted by mini-css-extract-plugin
export default {"container":"header-module__container___O5DHA","content":"header-module__content___fF0K4","navigation":"header-module__navigation___Ri0Ak"};